import { Info } from 'lucide-react';
import { LiksButton } from '../../components/liks/LiksButton/LiksButton';
import { useI18n } from '../../i18n/useI18n';
import { CrawlUrlDepthStepper } from './CrawlUrlDepthStepper';
import './CrawlUrlTree.css';

type CrawlUrlDepthControlsProps = {
  collapseDisplayDepth: number;
  expandDisplayDepth: number;
  disabled?: boolean;
  onCollapseDisplayDepthChange: (value: number) => void;
  onExpandDisplayDepthChange: (value: number) => void;
  onApplyCollapseDepth: () => void;
  onApplyExpandDepth: () => void;
  onShowCollapseInfo: () => void;
  onShowExpandInfo: () => void;
};

export function CrawlUrlDepthControls({
  collapseDisplayDepth,
  expandDisplayDepth,
  disabled = false,
  onCollapseDisplayDepthChange,
  onExpandDisplayDepthChange,
  onApplyCollapseDepth,
  onApplyExpandDepth,
  onShowCollapseInfo,
  onShowExpandInfo,
}: CrawlUrlDepthControlsProps) {
  const { translate } = useI18n();

  return (
    <div className="crawl-url-tree__depth-controls">
      <div className="crawl-url-tree__depth-control">
        <CrawlUrlDepthStepper
          value={collapseDisplayDepth}
          onChange={onCollapseDisplayDepthChange}
          ariaLabel={translate('knowledge.crawlSelectionCollapseLevelLabel')}
          decreaseLabel={translate('knowledge.crawlSelectionLevelDecrease')}
          increaseLabel={translate('knowledge.crawlSelectionLevelIncrease')}
          disabled={disabled}
        />
        <div className="crawl-url-tree__level-action">
          <LiksButton
            type="button"
            variant="secondary"
            disabled={disabled}
            onClick={onApplyCollapseDepth}
          >
            {translate('knowledge.crawlSelectionCollapseLevel')}
          </LiksButton>
          <button
            type="button"
            className="crawl-url-tree__level-info"
            aria-label={translate(
              'knowledge.crawlSelectionCollapseLevelInfoLabel',
            )}
            onClick={onShowCollapseInfo}
          >
            <Info
              className="crawl-url-tree__level-info-icon"
              strokeWidth={2}
              aria-hidden
            />
          </button>
        </div>
      </div>
      <div className="crawl-url-tree__depth-control">
        <CrawlUrlDepthStepper
          value={expandDisplayDepth}
          onChange={onExpandDisplayDepthChange}
          ariaLabel={translate('knowledge.crawlSelectionExpandLevelLabel')}
          decreaseLabel={translate('knowledge.crawlSelectionLevelDecrease')}
          increaseLabel={translate('knowledge.crawlSelectionLevelIncrease')}
          disabled={disabled}
        />
        <div className="crawl-url-tree__level-action">
          <LiksButton
            type="button"
            variant="secondary"
            disabled={disabled}
            onClick={onApplyExpandDepth}
          >
            {translate('knowledge.crawlSelectionExpandLevel')}
          </LiksButton>
          <button
            type="button"
            className="crawl-url-tree__level-info"
            aria-label={translate(
              'knowledge.crawlSelectionExpandLevelInfoLabel',
            )}
            onClick={onShowExpandInfo}
          >
            <Info
              className="crawl-url-tree__level-info-icon"
              strokeWidth={2}
              aria-hidden
            />
          </button>
        </div>
      </div>
    </div>
  );
}
